import { useQueryClient } from "@tanstack/react-query";
import { get } from "lodash";
import { useEffect, useState } from "react";

export interface BreadcrumbInQueryCacheProps {
  cacheKey: (string | number)[];
  name: string;
  fallback?: string;
}

export const BreadcrumbInQueryCache = ({
  cacheKey,
  name,
  fallback = "...",
}: BreadcrumbInQueryCacheProps) => {
  const queryClient = useQueryClient();

  const getCachedValue = () => {
    const query = queryClient.getQueryCache().find({
      queryKey: cacheKey,
      exact: false,
    });

    const data = query?.state.data;
    const value = get(data, name);

    return value ?? fallback;
  };

  const [crumbText, setCrumbText] = useState(getCachedValue);

  useEffect(() => {
    setCrumbText(getCachedValue());

    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      const isTargetQuery = cacheKey.every(
        (part, i) => event.query.queryKey[i] === part
      );

      if (event.type === "updated" && isTargetQuery) {
        const newValue = get(event.query.state.data, name);

        if (newValue !== undefined) {
          setCrumbText(newValue);
        }
      }
    });

    return () => unsubscribe();
  }, [cacheKey, name, getCachedValue, queryClient]);

  return <>{crumbText}</>;
};
